var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard/icon_+") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_\\uC0C1\\uD488\\uB4F1\\uB85D_\\uC635\\uC158\\uC124\\uC815",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_\\uC0C1\\uD488\\uB4F1\\uB85D_\\uC635\\uC158-\\uC124\\uC815\\uC2DC",
    transform: "translate(-1050.000000, -1943.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC635\\uC158_\\uC635\\uC158\\uC785\\uB825=2\\uAC1C-\\uC120\\uD0DD-\\uC2DC",
    transform: "translate(261.000000, 1815.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "con",
    transform: "translate(50.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC635\\uC158\\uD56D\\uBAA92",
    transform: "translate(200.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn_\\uC81C\\uAC70-copy",
    transform: "translate(528.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9084967,17.869281 C24.9084967,18.3493717 24.5193064,18.7385621 24.0392157,18.7385621 L11.869281,18.7385621 C11.3891904,18.7385621 11,18.3493717 11,17.869281 C11,17.3891904 11.3891904,17 11.869281,17 L24.0392157,17 C24.5193064,17 24.9084967,17.3891904 24.9084967,17.869281 Z",
    id: "dashboard/icon_+"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.9edf2d838ae1e185146b916ec6231fd9.svg";
export { ForwardRef as ReactComponent };